import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RatingComponentDef } from '@df/ui/common/rating.component.def';

@Component({
    selector: 'rating',
    templateUrl: './rating.html',
    styleUrls: ['./rating.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingComponent extends RatingComponentDef {}
